/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CertificateDto } from '../../models/certificate-dto';
import { CertificateUpdateDto } from '../../models/certificate-update-dto';

export interface CertificateAdminControllerUpdateV1$Params {
  id: string;
      body: CertificateUpdateDto
}

export function certificateAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: CertificateAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
  const rb = new RequestBuilder(rootUrl, certificateAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CertificateDto>;
    })
  );
}

certificateAdminControllerUpdateV1.PATH = '/api/v1/certificates/admin/{id}';
